export enum GroupStepTypeE {
  PARTICIPANT_ADDED = 'participantAdded',
  PARTICIPANT_REMOVED = 'participantRemoved',
  CALL_INITIATED = 'callInitiated',
  CALL_ENDED = 'callEnded',
  DAY = 'day',
}
